import { SiriusComponentModel } from 'sirius-framework';

export class CommonModel extends SiriusComponentModel {
    AdditionalInfo: string;
    Result: boolean;
    Error: string;
    ErrorM: ErrorModel;
    ChannelId: string;
}

export class SmsOtp extends SiriusComponentModel {
    success: string;
}

export class LogoutModel extends SiriusComponentModel {
    Channel: string;
    AppType: string;
}

export class ParamaterStatusModel extends SiriusComponentModel {
    Text: string;
    Value: string;
    AdditionalValue: string;
}

export class LoginModel extends SiriusComponentModel {
    TCKN: string;
    GsmNo: string;
    MaskedGsm: string;
    ShowCaptcha: string;
    WrongCaptchaEntry: boolean = false;
    SmsSent: boolean = false;
    SMSKey: string = null;
    SMSStatus: number = -1;
    SMSResult: string;
    ErrorMessage: string = null;
    ErrorCode: number = -1;
    LoginSuccess: boolean;  
    TcknDenendi: boolean = false;
    CaptchaModel: CaptchaModel;
    IsRegistered: boolean = false;
    MemberName: string;
    MemberSurname: string;
    PlateUsedBefore: string;
    RefNoUsedBefore: string;
    IsActUserControlOk: boolean = false;
    NeedExtraInfo: boolean = false;
    ActAsTst: boolean = false; //Frt
    UseKps: boolean = false; //Frt
    BirthDate: string; 
}

export class ReturnLoginModel extends SiriusComponentModel {
    ShowCaptcha: string;
    WrongCaptchaEntry: boolean = false;
    SmsSent: boolean = false;
    SMSKey: string = null;
    SMSStatus: number = -1;
    SMSResult: string;
    ErrorMessage: string = null;
    ErrorCode: number = -1;
    LoginSuccess: boolean;
    LoginIntBank: boolean;
    BWinfo: string;
    AppType: string;
    TcknDenendi: boolean = false;
    CaptchaDenendi: boolean = false;
    SmsDenendi: boolean = false;
    CaptchaValidated: boolean = false;
    IsRegistered: boolean = false;
    IsActUserControlOk: boolean = false;
    NeedExtraInfo: boolean = false;
    MemberName: string;
    MemberSurname: string;
    GetName: boolean = false;
}
 

export class CaptchaModel {
    CaptchaName: string;
    CaptchaValue: string;
    CaptchaValidated: boolean;
}

export class UIModel {
    IsLocalOrTestOrPreProd: boolean;
    IsLive: boolean;
    SiteLanguageCode: string;
}

export class SiteLanguageModel extends SiriusComponentModel {
    LanguageCode: string;
}

export class MailAddressValidationModel extends SiriusComponentModel {
    MailAddress: string;
    IsValid: boolean;
}

export class PhoneNumberValidationModel extends SiriusComponentModel {
    PhoneNumber: string;
    IsValid: boolean;
}

export class TCKNValidationModel extends SiriusComponentModel {
    Tckn: string;
    IsValid: boolean;
}

export class IBANValidationModel extends SiriusComponentModel {
    IBAN: string;
    IsValid: boolean;
    ResultMessage: string;
    ForceLogOut: boolean;
    UserType: string;
    Vkn: string;
}

export class VKNValidationModel extends SiriusComponentModel {
    VKN: string;
    IsValid: boolean;
    ForceLogOut: boolean;
    ResultMessage: string;
    Title: string;
    ControlOk: boolean;
}

export class VerifyIBANModel extends SiriusComponentModel {
    IBAN: string;
    ReturnCode: string;
    IsValid: boolean;
    Title: string; 
    UserType: string;
    ResultMessage: string;
    ForceLogOut: boolean;
}

export class DocumentViewModelList extends SiriusComponentModel {
    ViewModelList: DocumentViewModel[];
    Error: string;
}

export class DocumentViewModel extends SiriusComponentModel {
    DocumentId: string;
    TypeCode: string;
    Name: string;
    DocContentList: Array<string>;
}

export class EFTBankListModel extends SiriusComponentModel {
    BranchArray: Branch[];
}

export class Branch {
    BankShortName: string;
    BankFriendlyName: string;
    BankCode: string;
}

export class SharedModel {
    static YediEmin = 'YediEmin';
    static YediEminLogin = 'QNB Güvenli Ödeme Sistemi Giriş';

    static clickedBack = false;

    static resourcesLoad = false;

    static EnviromentInfo = "EnviromentInfo";
    static Dev = "Dev";
    static Test = "Test";
    static Preprod = "Pre";
    static Prod = "Prod";

    static BasvurunuzAlinmistir = "{0} başvurunuz alınmıştır.";
    static wrongEnvoyCode1 = "wrongEnvoyCode1";

    static DefaultChoose = "Seçiniz";
    static DefaultChooseValue = "000";
    static DefaultOther = "Diğer";
    static DefaultOtherValue = "0";


    static Default = "Default";

    static str0 = "0";
    static str1 = "1";
    static str2 = "2";
    static str3 = "3";
    static str5 = "5";
    static str6 = "6";
    static str13 = "13";
    static Empty = "";
    static DigitalStatement = "Dijital Ekstre"
    static Sposta = "Sposta";
    static SpostaWithDash = "S-posta";
    static Email = "Email";
    static EmailTransportationType = "E-Posta";
    static EPostaWithDash = "E-Posta";
    static Posta = "Posta";
    static GeneralErrorMessageHeader = "GeneralErrorMessageHeader";
    static GeneralErrorMessage = "GeneralErrorMessage";
    static GeneralErrorText = "Şu anda işleminize devam edemiyoruz lütfen daha sonra tekrar deneyiniz.";
    static Uyari = "Uyarı";
    static Evet = "Evet";
    static Hayir = "Hayır";

    static Adresinize = "adresinize";


    static ContactPermissionStatus = "ContactPermissionStatus";
    static Cep_Telefonunuza = "cep telefonunuza";
    static Space = " ";

    //
    static AppType = "AppType";

    static MemberGetMember = "MemberGetMember";
    static MemberGetMemberTermOfUse = "MemberGetMemberTermOfUse";



    static QnbFirstLibrary = "QnbFirstLibrary";
    static QnbFirstBookDetail = "QnbFirstBookDetail";
    //
    static AppTitle = "AppTitle";
    //
    static Main = "Main";
    static Login = "Login";
    static CurrentPage = "CurrentPage";
    static PageName_Login = "Login";
    static PageName_Landing = "/landing";

    static PageName_MainInnerPage = "Ana Sayfa";
    static PageName_Tercihler = "Tercihler";
    static PageName_Result = "Result";
    static PageName_Continue = "Continue";

    static PageName_Summary = "Summary";
    static PageName_Dummy = "Dummy";
    static PageName_Route = "Route";
    static PageName_Preferences = "Preferences";
    static PageName_TermOfUse = "TermOfUse";
    static Kvkk = "Kvkk";
    /** Çerez aydınlatma metni (HTML) — string kaynak anahtarı */
    static CookieInfo = "CookieInfo";
    static KvkkTitle = "KvkkHeader"
    static AydinlatmaHeader = "AydinlatmaHeader";
    static aydinlatma = "aydinlatma";
     
    static NotContinueByYourInput = "NotContinueByYourInput";
    static LogInUser: "LogInUser";
    static FirstMainPageInfo = "FirstMainPageInfo";
    static FirstMainPageInfoMobil = "FirstMainPageInfoMobil";

    static gtag_onay = "onay";


    static gtag_kullanim = "kullanim";
    static gtag_paraHesapta = "para-hesapta";
    static gtag_pageNameParaHesapta = "paraHesapta";
    static gtag_smtp = "smsotp";
    static gtag_pageViewSmsOtp = "sms-otp";
    static gtag_birinciRet = "birinciRet";
    static gtag_pvBirinciRet = "birinci-ret";
    static gtag_ikinciRet = "ikinciRet";
    static gtag_pvIkinciRet = "ikinci-ret";
    static gtag_ucuncuRet = "ucuncuRet";
    static gtag_pvUcuncuRet = "ucuncu-ret";
    static gtag_tanimlama = "tanimlama";
    static gtag_pvTanimlama = "tanimlama";
    static gtag_dokumanonayi = "dokumanonayi";
    static gtag_pvDokumanOnayi = "dokuman-onayi";



    //Dokuman başlıkları ve Kodları
    static InsuranceDocTitle = 'InsuranceDocTitle';
    static PaymentAndOtherDocTitle = 'PaymentAndOtherDocTitle';
    static PolicyDocTitle = 'PolicyDocTitle';
    static InsuranceDocCode = 'InsuranceDocCode';
    static PaymentAndOtherDocCode = 'PaymentAndOtherDocCode';
    static InsuranceDocumentPaymentAndOtherDocCode = 'InsuranceDocumentPaymentAndOtherDocCode';
    static PolicyDocCode = 'PolicyDocCode';
    static GetDocumentError = 'GetDocumentError';

    //validation kontrol isimleri

    static kimlikSeriNo1 = "kimlikSeriNo1";
    static kimlikSeriNo2 = "kimlikSeriNo1";

    static vergiNo = "vergiNo";
    static KimlikSeriNo1New = "KimlikSeriNo1New";

    static AccountList = "AccountList";
    static PageInfo_Ekmh_KmhDefined_NoLoggedInCustomer = "PageInfo_Ekmh_KmhDefined_NoLoggedInCustomer";
    static CustomerInfoModel = "CustomerInfoModel";
    static PleaseReadDoc = "İşleminize devam edebilmek için zorunlu dokümanları okuyup onaylamanız gerekmektedir.";

    static Accept = "Accept";
    static PercentFriendlyText = "{0} %";
    static RelatedDocs = "İlgili Formlar";
    static QnbFinansbankMainPage = "QnbFinansbankMainPage";
    static required = "required";
    static ImagePath = "www.google.com";
    static OfferedEkHesapLimitiMinMaxWarningText = "OfferedEkHesapLimitiMinMaxWarningText";
    static dTarihiMask = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    static dTarihiMaskPlaceHolder = "__/__/____";
    static cepTelMask = ['(', /[5]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    static telMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    static esignMask = [/\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, '-', /\w/, /\w/, /\w/, /\w/, '-', /\w/, /\w/, /\w/, /\w/, '-', /\w/, /\w/, /\w/, /\w/, '-', /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/];
    static birthDateText = "Doğum Tarihi";
    static IsReject = "IsReject";

    static KimlikSeriNo1 = "KimlikSeriNo1";
    static KimlikSeriNo2 = "KimlikSeriNo2";
    static DocUnreadWarningFirstPart = "Başvuruya devam etmek için lütfen ";
    static DocUnreadWarningSecondPart = " okuyup onaylayınız.";
    ;
    static SozlesmeEmailTextBox = "SozlesmeEmailTextBox";

    static LogOut = "LogOut";
    static LogOutModel = "LogOutModel";

    static home = "landing";
    static information = "information";
    static tercihler = "tercihler";
    static page = "landing";
    static tamamla = "tamamla";


    static docVal = "docval";
    static esignWarningText = "esignWarningText";

    static Virgul = ",";
    static Nokta = ".";

    static MgmEvaluationRecieved = 'MgmEvaluationRecieved';
    static MgmEvaluationRstSms = 'MgmEvaluationRstSms';
    static TRY = "TRY";
    static USD = "USD";
    static TooltipInfoElciKodu = "TooltipInfoElciKodu";
    static TooltipInfoKimlikSeriNo = "TooltipInfoKimlikSeriNo";
    static TooltipInfoEkstreGonderimTipi = "TooltipInfoEkstreGonderimTipi";
    static TooltipInfoPeriyodikLimitArtisi = "TooltipInfoPeriyodikLimitArtisi";
    static TooltipInfoEkstreHesapTipi = "TooltipInfoEkstreHesapTipi";
    static TooltipInfoInternettenAlisVerisTercihi = "TooltipInfoInternettenAlisVerisTercihi";
    static TooltipInfoEKartFinansSanalKart = "TooltipInfoEKartFinansSanalKart";
    static elciKoduBubbleInfo = "elciKoduBubbleInfo";
    static IsRouted = "IsRouted";

    static OneOneEight = "118";
    static ThreeOneFour = "314";
    static FourFiveZero = "450";
    static ZeroZeroNine = "009";

  static mailAddresMaxLength = 120;
}
export class AmountModel extends SiriusComponentModel {
    AmountFriendly: string;
    AmountDecimal: number;
    AmountFriendlyNoDigitsAfterPoint: string;
}

export class ErrorModel {
    Id: string;
    ErrorCode: string;
    HasError: string;
    Error: string;
}

export class TokenModel extends SiriusComponentModel {
    Token: string;
    ErrorMessage: string;
    Validated: boolean;
    HasAccount: boolean;
    LoginUser: boolean = false;
}


export class MoneyModel extends SiriusComponentModel {
    MoneyDec: number;
    MoneyStr: string;
}


export class ControlAppModel extends SiriusComponentModel {
    App: string;
    Up1: string;
    Up2: string;
    IsOk: boolean;
}

export class IdSerialNoTryModel extends SiriusComponentModel {
    Serial1: string;
    Serial2: number;
    SerailNoNew: string;
    Result: boolean;
    Error: ErrorModel;
}

export class GetStpTransactionForBuyerModel extends SiriusComponentModel {
    ApprovedCode: string;
    BalanceAfterOperatiom: string; 
    CorporateTransactionApprovalStatus: boolean; 
    CustomerType: string;
    Email: string;
    FirmReference: string;
    ResultIDGoi: string;
    Iban: string;
    IdentityNo: string;
    Name: string;
    ProcessDate: string;
    ProcessStatus: string;
    ProductNo: string;
    ReceiverConstraintType: string;
    ReceiverEmail: string;
    ReceiverIban: string;
    ReceiverIdentityNo: string;
    ReceiverName: string;
    ReceiverSurname: string;
    ReceiverTelephone: string;
    ResponseRefNo: number; 
    Surname: string
    TelephoneNo: string; 
    TransactionResult: string;
    TotalAmount: number;
    ResultMessage: string;
    ResultID: string;
    ResultCode: number;
}

export class MemberInfo extends SiriusComponentModel { 
    Name: string;
    Surname: string;
    PhoneNumber: string;
    PhoneNumberFormatted: string;
    Email: string;
    Identitynumber: string;  
    UpdatedFieldInfo: string;
    HasAcc: boolean;
    BirthDate: string;
    GetName: boolean = false;
}

export class AccInfoModel extends SiriusComponentModel { 
    Name: string;
    AccNumber: string;
}

export class AccModelList extends SiriusComponentModel {
    AccList: Array<AccInfoModel> 
}

export class CalculatedCommissionModel extends SiriusComponentModel {
    SalesAmount: number;
    CommissionAmount: number;
    IsControlOk: boolean;
}
